import { MarketingSEO } from '@/components/seo/MarketingSEO'
import { SEO_ROUTES } from '@/seo/seo-routes'
import IphoneMonitoringTopicTemplate from '@/components/IphoneMonitoringTopicTemplate'
import { iphoneMonitoringTopics } from '@/data/iphoneMonitoringTopics'

const topic = iphoneMonitoringTopics.find((t) => t.slug === 'snapchat')!
const related = iphoneMonitoringTopics.filter((t) => t.slug !== 'snapchat')

export default function IPhoneMonitoringSnapchat() {
  return (
    <>
      <MarketingSEO
        title={topic.title}
        description={topic.seoDescription}
        url={SEO_ROUTES.iphoneMonitoringSnapchat}
        image="/img/og/open_graph.png"
      />
      <IphoneMonitoringTopicTemplate topic={topic} relatedTopics={related} />
    </>
  )
}

